import React from "react";
import PropTypes from "prop-types";
import {
    Drawer,
    // Input,
    // Button,
    Row,
    Col,
    // Icon,
    Timeline,
    // Card,
    Tag
} from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchPayProCaseNotes } from "store/actions";
import { STATE_STATUS } from "constants/index";
// import { CaseNoteRecord } from "records/case-note-record";
// import shortID from "uuid/v4";
// import moment from "moment";
import SingleDayNotes from "./single-day-notes";
import { getDataFromQueryString } from "../utils";

class PayProCaseTaskNotes extends React.Component {
    state = {
        note: null
    };
    componentDidMount() {
        this.handleNotesFetch({});
    }

    componentDidUpdate(prevProps) {
        this.handleNotesFetch(prevProps);
    }

    handleNotesFetch = (prevProps) => {
        if (
            this.props.location.state &&
            this.props.location.state.case_notes &&
            this.props.location.state.case_notes.case_notes_view &&
            (!this.props.notesStatus ||
                this.props.notesStatus === STATE_STATUS.UNFETCHED)
        ) {
            this.props.fetchPayProCaseNotes(this.props.actionDetailsId);
        }

        if(prevProps.notesCreating && !this.props.notesCreating) {
            this.setState({
                note: null
            });
        }
    }

    hideCaseNote = () => {
        this.props.history.replace(`${this.props.location.pathname}?ordering=${getDataFromQueryString("ordering")}`, {
            ...this.props.location.state,
            case_notes: {
                case_notes_view: false
            }
        });
    };

    render() {
        return (
            <Drawer
                title={"Case Comments"}
                closable
                visible={
                    this.props.location.state &&
                    this.props.location.state.case_notes &&
                    this.props.location.state.case_notes.case_notes_view
                        ? true
                        : false
                }
                onClose={this.hideCaseNote}
                placement={"right"}
                width={"40vw"}
                footer={null}
            >
                <Row>
                    <Col span={24}>
                        <Row>
                            <Col
                                span={24}
                                style={{
                                    flexGrow: 1,
                                    minHeight: "65vh",
                                    maxHeight: "65vh",
                                    overflowY: "auto"
                                }}
                                className={"p-5"}
                            >
                                <Timeline>
                                    {this.props.notes &&
                                        this.props.notes
                                            .map((_, k) => (
                                                <Timeline.Item key={_.id}>
                                                    <div>
                                                        <Tag>
                                                            {k}
                                                        </Tag>
                                                    </div>
                                                    <SingleDayNotes 
                                                        notes={_}
                                                        deleteNote={this.deleteNote}
                                                        activateNote={this.activateNote}
                                                    />
                                                </Timeline.Item>
                                            ))
                                            .toList()}
                                </Timeline>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Drawer>
        );
    }
}

PayProCaseTaskNotes.propTypes = {
    caseId: PropTypes.number,
    actionDetailsId: PropTypes.number,
    companyId: PropTypes.number,
    user: PropTypes.object,
    stage: PropTypes.number,
    notesStatus: PropTypes.string,
    notes: PropTypes.object,
    fetchPayProCaseNotes: PropTypes.func,
    createCaseNote: PropTypes.func,
    location: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    stageId: PropTypes.string,
    deleteCaseNote: PropTypes.func,
    retrieveCaseNote: PropTypes.func,
    notesCreating: PropTypes.bool
};

const mapStateToProps = (state, props) => {
    const actionDetailsId =
        props.location.state &&
        props.location.state.case_notes &&
        props.location.state.case_notes.actionDetailsId;
    return {
        actionDetailsId: actionDetailsId,
        stageId: props.location.state &&
            props.location.state.case_notes &&
            props.location.state.case_notes.stageId,
        stage:
            props.location.state &&
            props.location.state.case_notes &&
            props.location.state.case_notes.stageId &&
            state.stages
                .get("data")
                .find(_ => _.id === props.location.state.case_notes.stageId),
        user: state.user.get("data"),
        notesStatus: state.caseNotes.getIn([actionDetailsId, "status"]),
        notes: state.caseNotes.getIn([actionDetailsId, "notes"]),
        notesCreating: state.caseNotes.getIn([actionDetailsId, "creating"], false)
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchPayProCaseNotes,
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PayProCaseTaskNotes);
